import React from "react";
import { toast } from "react-toastify";
import { MyGlobalContext } from "../../../Context";

const CardForm = ({
  setBankName,
  setCardNumber,
  setCardHolder,
  setCardExpire,
  cardNumber,
  setIsRotate,
  setCvv,
  OnSubmitPayment
}) => {
  const { totalPrice } = MyGlobalContext();

  const toastStyle = {
    position: "top-center",
    autoClose: 2000,
  };

  const BankNameOnChange = (e) => {
    const BankName = e.target.value;
    // console.log(isNaN(BankName));
    const regex = /^[A-Za-z]+$/;
    if(regex.test(BankName)) {
      setBankName(BankName);
    } else if(BankName === "") {
      setBankName("");
    } else {
      toast.warn("Can't use number or special characters or empty string!", toastStyle);
    }
  }
  const cardNumberOnChange = (event) => {
    const inputCardNumber = event.target.value;
    let formattedValue = "XXXX XXXX XXXX XXXX";

    if (!isNaN(inputCardNumber)) {
      for (let i = 0; i < inputCardNumber.length; i++) {
        formattedValue = formattedValue.replace("X", inputCardNumber[i]);
      }
      setCardNumber(formattedValue);
    } else {
      toast.warn("Can't type text! Input values must be numbers", toastStyle);
    }
  };

  const OnChangeCVV = (e) => {
    const value = e.target.value;
    if (isNaN(value)) {
      toast.warn("Input values must be numbers!", toastStyle);
    } else {
      setCvv(value);
    }
  };

  const CardHolderOnChange = (e) => {
    const holderName = e.target.value;
    const regex = /^[a-zA-Z\s]+$/
    if(regex.test(holderName)) {
      setCardHolder(holderName);
    } else if(holderName === "") {
      setCardHolder("");
    } else {
      toast.warn("Card Holder name must be proper name!", toastStyle);
    }
  }

  
  return (
    <section className="my-auto md:mr-10 bal-form">
      <h1 className=" text-white font-extrabold tracking-[0.2rem] text-center bank-name-shadow">
        Your Payment Details
      </h1>
      <h1 className="form-amount-details">Amount: ${totalPrice}</h1>
      <form onSubmit={OnSubmitPayment} className="w-[100%] max-w-[300px] text-white uppercase form-card">
        <label htmlFor="bankShortName">Bank Short Name</label>
        <input
          type="text"
          name="bankShortName"
          placeholder="e.g. BOC"
          id="bankShortName"
          onChange={BankNameOnChange}
          maxLength={6}
          autoComplete="off"
        />
        <label htmlFor="cardHolderName">Card Holder Name</label>
        <input
          type="text"
          placeholder="example@Jhon Deo"
          id="cardHolderName"
          autoComplete="off"
          onChange={CardHolderOnChange}
        />
        <label htmlFor="cardNumberInput">Credit Card Number</label>
        <input
          id="cardNumberInput"
          type="text"
          placeholder="1234 4567 2121 4465"
          onChange={cardNumberOnChange}
          maxLength={16}
          autoComplete="off"
            // value={cardNumber}
            pattern="[0-9\s]{13,19}"
        />
        <div className="flex justify-between">
          <div className=" w-1/2 m-1">
            <label htmlFor="expireDate">Exp Date</label>
            <input
              type="month"
              onChange={(e) => setCardExpire(e.target.value)}
              id="expireDate"
            />
          </div>
          <div className="w-1/2 m-1">
            <label htmlFor="cvv">cvc/Cvv</label>
            <input
              type="text"
              placeholder="XXX"
              id="cvv"
              autoComplete="off"
              maxLength={6}
              onChange={OnChangeCVV}
              onMouseEnter={() => setIsRotate(true)}
              onMouseLeave={() => setIsRotate(false)}
            />
          </div>
        </div>
        <button type="submit" className="border-2 rounded-sm text-white mt-3 form-pay-btn">
          Pay Now
        </button>
      </form>
    </section>
  );
};

export default CardForm;
